<div class="text-center text-white mt-5">
    <img src="assets/images/page-not-found.png" alt="Page Not Found" class="img-fluid">
    <h3>Sorry, the page not found.</h3>
    <p>The link you followed probably broken or the page has been removed.</p>
    <p class="mt-4"><a routerLink="/dashboard" class="btn btn-success btn-sm">Return to Dashboard</a></p>
</div>
